import { defineStore } from "pinia";
import { ref } from "vue";

export const useNotificationStore = defineStore("notification", () => {
  const visible = ref(false);
  const message = ref("");

  const show = (text, duration = 2000) => {
    message.value = text;
    visible.value = true;

    setTimeout(() => {
      visible.value = false;
    }, duration);
  };

  return { visible, message, show };
});
